// Logo ufficiale DS LAB STUDIO (asset: /public/logo.png).
// Non ridisegnare né modificare: per sostituirlo basta aggiornare il file
// frontend/public/logo.png (stesso nome) oppure il percorso qui sotto.
// La favicon usa il monogramma DS: /public/favicon.png
export const Logo = ({ variant = "dark" }) => {
  if (variant === "light") {
    // Su sfondo scuro (footer) il logo viene presentato su un badge bianco
    // neutro, senza alcuna modifica al file del logo.
    return (
      <span className="inline-flex items-center rounded-lg bg-white px-3.5 py-2.5">
        <img src="/logo.png" alt="DS LAB STUDIO" className="h-9 w-auto" width="458" height="324" />
      </span>
    );
  }
  return (
    <img src="/logo.png" alt="DS LAB STUDIO" className="h-10 w-auto sm:h-11" width="458" height="324" />
  );
};
